import React from 'react'
import './methodology.css';
import { Document, Page } from 'react-pdf';
import referencePDF from '../../assets/images/reference.pdf';
import conference from '../../assets/images/conferenceCover.png'
import { Link, useParams } from 'react-router-dom';

const Resources = ({ }) => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'instant',
  });

  let getWidth = () => {
    var scWidth = Math.max(document.body.scrollWidth, document.documentElement.scrollWidth, document.body.offsetWidth, document.documentElement.offsetWidth, document.documentElement.clientWidth);

    if(scWidth*0.65 > 1110) {
        scWidth = 1000;
    } else {
        scWidth = scWidth*0.65;
    }

    return scWidth;
}

let pdf = useParams()["*"];
    if(pdf!="") {
        console.log("pdf name " + pdf);
        

        return (
        <div style={{width:getWidth(), marginLeft:"50%", transform:"translateX(-50%)"}}>
            <Link style={{paddingTop:"10px", paddingBottom:"0px", textAlign:"center", minHeight:"45px", marginRight:"0px", display:"inline-block", marginBottom:"20px", minWidth:"125px"}} className={"btn btn-primary"} to="/resources">&#60; Back</Link>
            
            <div className="card" style={{width:getWidth(), padding:"30px 15px 0px 15px"}}>
                <a target="_blank" href={referencePDF}>
                <Document 
                    file={referencePDF}
                    onLoadSuccess={() => console.log("file loaded")}
                    options={{ withCredentials: true }}
                >
                    {Array.apply(null, Array(51)).map((x, i)=>i+1).map(page => (
                        <Page pageNumber={page} width={(getWidth())-20} renderAnnotationLayer={false} renderInteractiveForms={false}/>
                    ))}
                </Document>
                </a>
            </div>
        </div>
    )
    }


return (
        <div className="container" style={{paddingBottom:"35px"}}>
            <div >
              <div className="column60" style={{padding:"0px"}}>

              <h2 style={{marginTop:"15px"}}><strong>References</strong></h2>
                <Link style={{whiteSpace:"nowrap", margin:"10px", paddingLeft:"70px", paddingRight:"70px", textAlign:"center", backgroundColor:"#F6D25C", borderColor:"#F6D25C", color:"#212121"}} to="/resources/pcam" className="btn btn-primary mt-3">PCAM Toolkit</Link>
              </div>

              <div className="column60" style={{padding:"0px"}}>
              <h2 style={{marginTop:"15px"}}><strong>Calculators</strong></h2>
                <Link style={{whiteSpace:"nowrap", margin:"10px", paddingLeft:"70px", paddingRight:"70px", textAlign:"center", backgroundColor:"#F6D25C", borderColor:"#F6D25C", color:"#212121"}} to="/additional-resources" className="btn btn-primary mt-3">STOP BANG</Link>
                <Link style={{whiteSpace:"nowrap", margin:"10px", paddingLeft:"70px", paddingRight:"70px", textAlign:"center", backgroundColor:"#F6D25C", borderColor:"#F6D25C", color:"#212121"}} to="/additional-resources" className="btn btn-primary mt-3">Child-Pugh</Link>
                <Link style={{whiteSpace:"nowrap", margin:"10px", paddingLeft:"70px", paddingRight:"70px", textAlign:"center", backgroundColor:"#F6D25C", borderColor:"#F6D25C", color:"#212121"}} to="/additional-resources" className="btn btn-primary mt-3">CKD-Epi</Link>
                <Link style={{whiteSpace:"nowrap", margin:"10px", paddingLeft:"70px", paddingRight:"70px", textAlign:"center", backgroundColor:"#F6D25C", borderColor:"#F6D25C", color:"#212121"}} to="/additional-resources" className="btn btn-primary mt-3">BMI (Adult)</Link>
                <Link style={{whiteSpace:"nowrap", margin:"10px", paddingLeft:"70px", paddingRight:"70px", textAlign:"center", backgroundColor:"#F6D25C", borderColor:"#F6D25C", color:"#212121"}} to="/additional-resources" className="btn btn-primary mt-3">COWS</Link>
              </div>

              <div className="column60" style={{padding:"0px"}}>
              <h2 style={{marginTop:"15px"}}><strong>Medication Switching and Discontinuation</strong></h2>
                <Link style={{whiteSpace:"nowrap", margin:"10px", paddingLeft:"70px", paddingRight:"70px", textAlign:"center", backgroundColor:"#F6D25C", borderColor:"#F6D25C", color:"#212121"}} to="/additional-resources" className="btn btn-primary mt-3">Antidepressant Switching and Discontinuation</Link>
                <Link style={{whiteSpace:"nowrap", margin:"10px", paddingLeft:"70px", paddingRight:"70px", textAlign:"center", backgroundColor:"#F6D25C", borderColor:"#F6D25C", color:"#212121"}} to="/additional-resources" className="btn btn-primary mt-3">Mood Stabilizer Switching and Discontinuation</Link>
              </div>
            </div>
        </div>
)
    
};

export default Resources